import { Box, Card, CardContent, Typography } from "@mui/material";
import { Divider } from "../../widgets";
import { BrandNameUpdate } from "../../../utils/commonFunctions/BrandNameUpdate";
import Offers from "../PlanCard/Offers/Offers";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import NetworkCheckIcon from "@mui/icons-material/NetworkCheck";
import MobileFriendlyIcon from "@mui/icons-material/MobileFriendly";
import SavingsIcon from "@mui/icons-material/Savings";

const WowServices = (props: any) => {
  const { appSection } = props;
  return (
    appSection && (
      <>
        {appSection?.offers ? <Offers offerContent={appSection} /> : null}
        <Box sx={{ backgroundColor: "var(--app_section_bg_color)" }}>
          <Box
            sx={{
              width: "100%",
              paddingTop: { xs: "30px", sm: "90px" },
            }}
          >
            <Typography
              variant="h2"
              sx={{
                textAlign: "center",
                fontFamily: " var(--font_family_Bold)",
                color: appSection?.res?.headingColor
                  ? appSection?.res?.headingColor
                  : "var(--text_color_12)",
                fontSize: { xs: "26px", sm: "30px" },
                fontWeight: "var(--font_weight_4)",
              }}
            >
              {appSection?.appSectionHeading}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              flexDirection: { md: "row", xs: "row" },
              padding: {
                xs: "0px 20px",
                lg: "40px 72px",
              },
              // background: "var(--app_section_bg_color)",
              paddingTop: { xs: "30px", sm: 0 },
              gap: { xs: "20px", sm: "40px" },
              overflowX: "auto",
              "&::-webkit-scrollbar": {
                display: "none",
              },
              WebkitOverflowScrolling: "touch",
            }}
          >
            {appSection?.appSectionData.map((item: any, index: any) => {
              return (
                <Card
                  sx={{
                    width: "100%",
                    padding: { xs: "31px 25px", sm: "40px 20px" },
                    boxSizing: "border-box",
                    border: "1px solid var(--app_section_bg_color)",
                    boxShadow: "none",
                    borderRadius: "10px",
                    overflow: "initial",
                    maxHeight: { xs: "240px", sm: "" },
                  }}
                  key={index}
                >
                  <CardContent
                    sx={{
                      padding: "0 !important",
                      display: { xs: "flex" },
                      flexDirection: { xs: "column", md: "column" },
                      width: { xs: "280px", sm: "fit-content" },
                    }}
                  >
                    <Box
                      // component="img"
                      // alt={item?.image?.data?.attributes?.alternativeText}
                      // src={item?.image?.data?.attributes?.url || ""}
                      // height="40px"
                      // sx={{
                      //   width: "58px",
                      // }}
                      sx={{
                        backgroundColor: "var(--light_primary_color)",
                        width: "30px",
                        borderRadius: "25px",
                        padding: "10px",
                        height: "30px",
                        alignItems: "center",
                        display: "flex",
                        justifyContent: " center",
                      }}
                    >
                      {index == 0 && (
                        <TouchAppIcon
                          sx={{
                            color: "var(--primary_color)",
                          }}
                        />
                      )}
                      {index == 1 && (
                        <NetworkCheckIcon
                          sx={{
                            color: "var(--primary_color)",
                          }}
                        />
                      )}
                      {index == 2 && (
                        <MobileFriendlyIcon
                          sx={{
                            color: "var(--primary_color)",
                          }}
                        />
                      )}
                      {index == 3 && (
                        <SavingsIcon
                          sx={{
                            color: "var(--primary_color)",
                          }}
                        />
                      )}
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          fontSize: "18px",
                          fontFamily: "var(--font_family_Semibold)",
                          marginTop: { xs: "21px" },
                          color: "var(--text_color_12)",
                          fontWeight: "var(--font_weight_1) !important",
                          ml: "0px",
                          lineHeight: "30px",
                        }}
                        gutterBottom
                      >
                        {item.title}
                      </Typography>
                      <Typography
                        variant="h5"
                        component="div"
                        sx={{
                          fontSize: "14px",
                          marginTop: { xs: "18px" },
                          fontFamily: " var(--font_family_Regular)",
                          color: "var(--text_color_12)",
                          lineHeight: "28px",
                          width: "100%",
                        }}
                      >
                        {BrandNameUpdate(item.description)}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              );
            })}
          </Box>
        </Box>
      </>
    )
  );
};

export default WowServices;
